module.exports = __webpack_public_path__ + "img/cake.be5030ca.webp";